export class TimerManager {
    private timers = new Set<ReturnType<typeof setTimeout>>();

    add(timer: ReturnType<typeof setTimeout>) {
        this.timers.add(timer);
        return timer;
    }

    clear(timer: ReturnType<typeof setTimeout>) {
        clearTimeout(timer);
        this.timers.delete(timer);
    }

    clearAll() {
        this.timers.forEach(clearTimeout);
        this.timers.clear();
    }
}

export function withTimeout(promise: Promise<any>, ms = 1000, lateSuccessLogger?: Function, lateErrorLogger?: Function) {
    return new Promise((resolve, reject) => {
        let isTimeouted = false;
        const timer = setTimeout(() => {
            isTimeouted = true;
            reject(new Error('Timeout'))
        }, ms);

        promise
            .then(res => {
                clearTimeout(timer);
                if (isTimeouted && lateSuccessLogger) {
                    lateSuccessLogger("withTimeout() Promise resovled after timeout. Res:", res);
                }
                resolve(res);
            })
            .catch(err => {
                clearTimeout(timer);
                if (isTimeouted && lateErrorLogger) {
                    lateErrorLogger("withTimeout() Promise rejected after timeout. Err:", err);
                }
                reject(err);
            });
        ;
    })
}

